import { render, staticRenderFns } from "./ship.svg.vue?vue&type=template&id=0b394d58&"
import script from "./ship.svg.vue?vue&type=script&lang=js&"
export * from "./ship.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports